import React from 'react';
import { Alert, Box, Button, ExpandableSection, SpaceBetween } from '@amzn/awsui-components-react';
import CONSTANTS from 'src/utils/constants';
import AllocationGroup from 'src/models/tp-allocation/AllocationGroup';
import { ACTIONS } from 'src/services/tp-allocation/allocation-groups/AllocationGroupsReducer';
import { DasAllocationGroupsContext } from 'src/services/derived-allocation-sheet/DasAllocationGroupsContext';
import DasAllocationFormulasGrid from './DasAllocationFormulasGrid';

/**
 * One Step 3 allocation group, adapted from the TPA group container; keep the two in sync. Edit and Delete
 * group are offered on the editable draft only. The group's formulas show in a grid; a group-level error from
 * the section shows under it.
 */
export default function DasAllocationGroup({ group }: { group: AllocationGroup }) {
    const { groupsDispatch, viewMode, saving } = React.useContext(DasAllocationGroupsContext);
    const editable = viewMode === CONSTANTS.VIEW_MODE.EDITABLE;

    return (
        <ExpandableSection data-class="polarisExpandableSection" variant="container" defaultExpanded
                           headerText={group.description} headerDescription={group.allocationGroupDescription}
                           headerActions={editable && (
                               <SpaceBetween direction="horizontal" size="xs">
                                   <Button data-class="subPrimaryButton" className={`dasGroupEdit${group.allocationGroupId}`} disabled={saving}
                                           onClick={() => groupsDispatch(ACTIONS.SET_GROUP_BEING_EDITED.withPayload(group))}>Edit</Button>
                                   <Button data-class="subPrimaryButton" className={`dasGroupDelete${group.allocationGroupId}`} disabled={saving}
                                           onClick={() => groupsDispatch(ACTIONS.SET_REMOVE_GROUP_MODAL_PAYLOAD.withPayload(group))}>Delete group</Button>
                               </SpaceBetween>
                           )}>
            <div className="dataSourceTableContainer">
                <DasAllocationFormulasGrid group={group} />
            </div>
            {group.errorMessage && (
                <Box padding={{ top: 's' }}>
                    <Alert type="error" header="Allocation group error">{group.errorMessage}</Alert>
                </Box>
            )}
        </ExpandableSection>
    );
}
